<template>
  <div>
    <el-card class="box-card">
      <div style="overflow: hidden;">
        <ul class="list-left">
          <div class="list-left-top">
            <div style="width: 100%;overflow: hidden;">
              <div style="width: 76%;float: left;margin-left:2%;">
                <el-input clearable size="mini" :placeholder="$t('message.placeholder.input')" @clear="searchLists"
                  @keyup.enter.native="searchLists" v-model="search" class="input-with-select"
                  style="margin:0 20px 0 0">
                  <el-button slot="append" icon="el-icon-search" @click="searchLists"></el-button>
                </el-input>
              </div>
              <div style="float: left;margin-left:2%;">
                <el-button type="success" size="mini" icon="el-icon-circle-plus-outline"
                  @click="createUserTable = true"></el-button>
              </div>
            </div>
          </div>
          <li v-for="(item, index) in userList" :key="item.id" :title="item.name"
            :class="{ isDisable: item.enabled == 0, active: index == num }">
            <div style="display: flex;align-items: center; ">
              <div class="list-left-label" @click="dbClick(item, index)">
                {{ item.listTypeName + "(" + item.userName + ")" }}
              </div>
              <div style="margin-left: auto;margin-right: 10px;">
                <el-switch v-model="listEnabled[index].value" active-color="#13ce66" @change="changeUserStatus(item)">
                </el-switch>
              </div>

            </div>
            <!-- <span class="list-left-label" @click="dbClick(item, index)">
              {{ item.listTypeName }} ( {{ item.userName }} )
            </span>
            <span style="position: relative;top: -5px;left: 12px;">
              <el-switch v-model="listEnabled[index].value" active-color="#13ce66" @change="changeUserStatus(item)">
              </el-switch>

            </span> -->
          </li>
        </ul>

        <div class="list-right" v-show="showRight">
          <Tab @click="tabClick" />
          <router-view :key="key" @update="getUp" @routeClick='reload'></router-view>
        </div>

      </div>
    </el-card>

    <el-dialog :close-on-click-modal="false" class="searchAddBomList" v-if='createUserTable'
      :title="$t('message.title.add')" :visible.sync="createUserTable">
      <CreateUserTable :pageInfo='userName' @buttonClick='userCreate'></CreateUserTable>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import Tab from "./components/Tab.vue";
import CreateUserTable from '../../userConfig/user/CreateUser.vue'
export default {
  data() {
    return {
      num: -1,
      listEnabled: [],
      input_width: {
        width: "50%",
      },
      search: "",
      basicData: [],
      listNames: [],
      createForm: {
        name: "",
        listType: "1",
        description: "",
        enabled: "1",
        codeValueLength: "",
      },
      addShow: false,
      form: {
        name: "",
      },
      userList: [],
      seekList: [],
      userName: [],
      createUserTable: false,
      userInfo: [],
      showRight: false,
    };
  },
  mounted() { },
  components: { CreateUserTable, Tab },
  computed: {
    key() {
      // return new Date().getTime();
      const { id } = this.$route.query;
      return id
    }
  },
  created() {
    this.$store.commit('setShowUserName', '');
    this.getUserList();
  },
  methods: {
    updateLists(val) {
      if (val) {
        this.getUserList()
      };
    },
    getUp() {
      this.getUserList()
    },
    reload(e) {
      if (e == undefined) {
        this.logoInfo();
        return
      }
      const obj = {
        id: e.itemId,
        classId: e.itemClassId,
        subClassId: e.itemSubClassId,
        title: e[0]
      };
      this.getLink(obj);
    },

    dbClick(row, index) {
      console.log(row);


      this.showRight = true;
      this.userInfo = row;
      this.num = index;
      this.$store.commit("setListId", row.id);

      const query = {
        id: row.itemId,
        classId: row.itemClassId,
        subClassId: row.itemSubClassId,
        // listTypeName: row.listTypeName
      };

      this.$store.commit('setObjectId', query);
      this.$store.commit('setShowUserName', row.listTypeName + "(" + row.userName + ")");

      let obj = {
        path: '/Users/UserInfo',
        query: { ...query, listTypeName: row.userName }
      };
      console.log(query);

      this.$router.push(obj);
    },
    searchLists() {
      if (!this.search) {
        this.userList = this.basicData;
        this.listEnabled = this.basicData.map((item, index) => ({
          value: item.status
        }));
        return;
      }
      const searchTerm = this.search.toLowerCase();
      let searchVal = [];
      this.basicData.forEach(item => {
        if (item.listTypeName.toLowerCase().includes(searchTerm)) {
          searchVal.push(item);
        }
      });
      this.listEnabled = searchVal.map((item, index) => ({
        value: item.status
      }));
      this.userList = searchVal;
    },
    changeUserStatus(row) {
      const object = {
        changeId: {},
        objectId: {
          classId: row.itemClassId,
          id: row.itemId,
          subClassId: row.itemSubClassId,
          version: "0",
        },
        pageOne: { 1090002: row.status ? "0" : "1" }, // 根据 row.status 动态设置值
        pageTwo: {},
        pageThree: {},
      };
      axios.post('/pmdm/admin/user/update', object).then(res => {
        if (res.data && res.data.code === 200) {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'success'
          });
          this.getUserList();
        } else {
          console.error('请求未成功:', res.data.message || '未知错误');
        }
      })
        .catch(error => {
          console.error('请求失败:', error.message || '网络请求出错');
        });
    },
    userCreate() {
      this.getUserListT();
    },
    async getUserListT() {
      const { data: res } = await this.$http.get("/pmdm/admin/user/getUsersForAdmin");

      this.userList = this.getNewTableContentData(res);
      this.searchList = this.getNewTableContentData(res);
      let arr = res.object.table.rows;
      for (let i = 0; i < arr.length; i++) {
        const e = arr[i];
        this.userName.push(e.cells[0].val);
      }
    },
    async getUserList() {
      this.input_width = this.Global.input_width_small;
      try {
        const res = await axios.get("/pmdm/admin/user/getUsersForAdmin");
        const listData = res.data.object.table.rows;
        this.listEnabled = listData.map((item, index) => ({
          value: item.cells[3].id === "0" ? false : true
        }));
        this.userList = listData.map((item, index) => ({
          index: index,
          itemClassId: item.objClass,
          itemId: item.objId,
          itemSubClassId: item.objSubClass,
          status: item.cells[3].id === "0" ? false : true,
          listTypeName: item.cells[0].val,
          userName: item.cells[1].val,
        }));
        this.basicData = this.userList;
        this.listNames = listData.map(i => i.cells[0].val);
        this.dbClick(this.basicData[0], 0);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    tabClick(e) {
      let query = this.$route.query;
      const { path } = e;
      this.$router.push({ path, query });
    },
  }

};
</script>

<style scoped>
.demo-ruleForm {
  width: 60%;
}

.add_form {
  padding: 15px 0;
  background: #fff;
}

.list-right {
  width: 76%;
  height: 740px;
  overflow: auto;
  padding: 0;
  float: left;
  border: 2px solid #ebebeb;
  margin: 0 0 0 16px;
}

.list-left {
  width: 21%;
  height: 740px;
  overflow: auto;
  padding: 0;
  border: 2px solid #ebebeb;
  float: left;
  position: relative;
  margin: 0;
}

.list-left-top {
  width: 100%;
  padding: 10px 0;
  background: #ebebeb;
  position: sticky;
  top: 0;
  z-index: 100;
}

.list-left li {
  padding: 4px;
  height: 20px;
}

.list-left li:hover {
  background: #5cb0f8;
  color: #fff;
}

.list-left-label {
  /* display: inline-block; */
  /* width: 72%; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  cursor: pointer;
  flex: 1;
}

.isDisable {
  color: rgb(255, 11, 0);
}

.active {
  background: #5cb0f9;
  color: #fff;
}
</style>